// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tenant-branding-images__block{display:block;margin-bottom:12px}.tenant-branding-images__block:last-child{margin-bottom:0}.tenant-branding-images__label{display:block;font-size:14px;margin-bottom:8px}.tenant-branding-images__wrapper{position:relative;display:inline-block;margin-bottom:8px}.tenant-branding-images__helper{display:block;font-size:12px;font-style:italic}.tenant-branding-images__error{display:block;margin-bottom:8px;font-size:12px;color:#b70000}", ""]);
// Exports
module.exports = exports;
